import React, { useState, useEffect, useRef } from "react"
import { getToken } from "../../firebaseInit.js"

async function postData(url = "", data = {}) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data),
  })
  return response.json()
}

// Call this ONLY from inside a click / submit handler (e.g. Login button).
// Firefox & Safari block Notification.requestPermission() if it is called
// on page load or after an `await`.
export const requestNotificationPermission = () => {
  if (!("Notification" in window)) return Promise.resolve("unsupported")
  if (Notification.permission !== "default") {
    return Promise.resolve(Notification.permission)
  }
  // must be called synchronously inside the user event — do NOT await anything before this
  return Notification.requestPermission()
}

// FOR BACKGROUND NOTIFICATION AND GET TOKEN
const FirebaseNotifications = props => {
  const [isTokenFound, setTokenFound] = useState(false)
  const hasSyncedRef = useRef(false)
  const inProgressRef = useRef(false)
  console.log("Token found", isTokenFound)

  useEffect(() => {
    let intervalId

    const trySyncToken = async () => {
      if (hasSyncedRef.current || inProgressRef.current) return

      // Don't ask for permission here (no user click) — just wait until
      // the user has granted it from the Login button / enable button.
      if (!("Notification" in window) || Notification.permission !== "granted") {
        return
      }

      const authUser = JSON.parse(localStorage.getItem("authUser"))
      if (!authUser?.EmailAddress) return

      inProgressRef.current = true
      try {
        // Fetch token INSIDE the retry, so it works once permission
        // is granted later (previously it was fetched only once on mount)
        const token = await getToken()

        if (!token) {
          console.log("FCM token not available yet, will retry")
          return
        }

        await postData(`${process.env.REACT_APP_ADMIN}/login/update/fcm`, {
          Email: authUser.EmailAddress,
          Token: token,
        })

        console.log("FCM token saved for", authUser.EmailAddress)
        setTokenFound(true)
        hasSyncedRef.current = true
        clearInterval(intervalId)
      } catch (error) {
        console.error("Failed to sync FCM token:", error)
      } finally {
        inProgressRef.current = false
      }
    }

    // First immediate attempt
    trySyncToken()

    // Keep retrying until permission is granted + user logged in + token saved
    intervalId = setInterval(trySyncToken, 5000)

    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [])

  return <></>
}

FirebaseNotifications.propTypes = {}

export default FirebaseNotifications